import React, { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../store/features/pageConfig';
import { selectCoursePricing } from '../../../../../../store/features/coursePricing';
import { StyledDownloadBrochureLinkProps } from '../../styledComponents';

export type DownloadBrochureProps = {
  ctaUrl?: string;
  ctaText?: string;
  newTab?: boolean;
  as: ComponentType<StyledDownloadBrochureLinkProps>;
};
export const DownloadBrochure = ({
  ctaUrl,
  ctaText,
  newTab,
  as: Component,
}: DownloadBrochureProps) => {
  const { t } = useTranslation();

  const {
    pageConfig: { sitePath },
    coursePricing: { courseBrochure = {} },
  } = useRootSelector((state) => ({
    pageConfig: selectPageConfig(state),
    coursePricing: selectCoursePricing(state),
  }));

  const {
    file: { filename: fileName = '' } = {},
    ctaUrl: brochureCtaUrl,
    ctaText: brochureCtaText,
    openInNewTab: brochureNewTab,
  } = courseBrochure;

  if (!fileName && !ctaUrl && !brochureCtaUrl) {
    return null;
  }

  const download = !ctaUrl && !brochureCtaUrl;
  const brochureUrl =
    ctaUrl ||
    brochureCtaUrl ||
    `${sitePath}/downloads/course/brochure/${fileName}`;
  const brochureText =
    ctaText ||
    brochureCtaText ||
    t('site.modules.course-option-display.link.download-brochure.label');

  return (
    <Component
      to={brochureUrl}
      text={brochureText}
      newTab={newTab || brochureNewTab}
      download={download}
    />
  );
};
